import {MitarbeiterTyp} from "../api";
import {useT} from "../i18n";

function useMitarbeiter() {
    const { t: translation } = useT("customer");

    const mitarbeiterTypen: MitarbeiterTyp[] = [
        "AZUBI",
        "ANGESTELLTER",
        "GEWERBLICHER",
    ];

    return {
        translation,
        mitarbeiterTypen,
    }
}

export default useMitarbeiter;